import { Outlet } from 'react-router-dom';

/** No persistent tab strip - the Dashboard itself is the hub, with clickable icon-tile cards linking to each area (already built). Removed per explicit feedback, same fix already applied to the HR workspace. */
export function StaffWorkspaceLayout() {
  return (
    <div className="page">
      <Outlet />
    </div>
  );
}
